<template>
      
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
            
            
            <!-- ============================================================== -->
            <!-- Start right Content here -->
            <!-- ============================================================== -->
            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">
                        
                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">认证专区</h4>
      
                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                      <li class="breadcrumb-item"><a href="#">认证专区</a></li>
                                                      <li class="breadcrumb-item active">首次认证</li>
                                                </ol>
                                          
                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              <!-- end row -->
                        
                        
                              <div class="row">
                                    <div class="col-md-12">
                                          <div class="card-box">
                                                <div class="row">
                                                      <div class="col-12">
                                                            
                                                      
                                                            <h1 class="display-1" style="font-size: 1.75rem !important;">微信支付二维码</h1>
                                                            <p class="text-muted"><img v-bind:src="ewmhtml"  style="height: 150px;width:150px;"></p>
                                                      
                                                            <div class="clearfix"></div>
                                                      
                                                           
                                                      </div>
                                          
                                                </div>
                                          
                                          
                                                <!-- end row -->
                                    
                                          </div>
                                    </div>
                        
                              </div>
                              <!-- end row -->
                  
                  
                        </div> <!-- container -->
            
                  </div> <!-- content -->
      
                  <!--footer-->
      
            </div>
            
            
            <!-- ============================================================== -->
            <!-- End Right content here -->
            <!-- ============================================================== -->
      
      
      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'main',
            components:{topbar,left},
            data() {
                  return {
                        orderid:this.$route.params.orderid,
                        ewmhtml:this.ewmhtml,
                  }
            },
            mounted(){
                  console.log(this.orderid);
                  this.wechatpay(this.orderid)
            },
            methods: {
                  wechatpay: function (orderid) {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/pay/rz_wechatpay/' + orderid
                        }).then(function onSuccess(response) {
                              //success
                              if (response.status === 200) {

                                    this.ewmhtml = response.data.ewmimgurl;
                                    
                                    //document.getElementById('next').style.display = "none";
                                    //这里开始检测是否付款，如果付款则跳转到扫码成功页面
                                    this.checkwachatpay(orderid);
                                    //alert(ewmhtml);

                                    //over--check


                              }

                        }.bind(this)).catch(function onError(response) {
                              //error
                        })

                  },
                  checkwachatpay: function (orderid) {
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/pay/rz_checkwechatpay/' + orderid
                        }).then(function onSuccess(response) {
                              //success
                              if (response.status === 200) {

                                    if (response.data.code === 0) {
                                          console.log('success');
                                          swal(
                                                {
                                                      title: '支付成功！',
                                                      text: '',
                                                      type: 'success',
                                                      confirmButtonColor: '#4fa7f3',
                                                }
                                          )
                                          window.location.href = '/member2/#/Authentication_fapiao?out_trade_no='+orderid;
                                    } else {
                                          console.log('false');
                                          this.setTimeout(this.checkwachatpay(orderid), 5000);
                                    }


                              }

                        }.bind(this)).catch(function onError(orderid) {
                              //error
                              //setTimeout(this.checkwachatpay(orderid),2000);
                        })
                        //setTimeout(this.checkwachatpay,2000);


                  },

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}

  
     
</style>



// WEBPACK FOOTER //
// src/components/Authentication_wechatpay_erweima.vue